import { Component, HostListener, inject, input, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VbLxpMapComponent } from '../../map/map.component';
import { VbLxpPanelComponent } from '../../panel/vb-lxp-panel.component';
import { PanelService } from '../../panel/panel.service';
import { RaceSessionService } from '../../timing-tower/race-session.service';

@Component({
	selector: 'vb-lxp-responsive-map',
	standalone: true,
	imports: [CommonModule, VbLxpMapComponent, VbLxpPanelComponent],
	templateUrl: './vb-lxp-responsive-map.component.html',
	styleUrl: './vb-lxp-responsive-map.component.css',
})
export class VbLxpResponsiveMapComponent implements OnInit {
	private readonly BREAKPOINT = 1000;
	private readonly raceSessionService = inject(RaceSessionService);
	public readonly panelService = inject(PanelService);

	public isLargeScreen = signal(false);
	public selectedDrivers = signal([]);
	public showTurnLabels = input(true);

	readonly drivers = this.raceSessionService.raceTeamsPosition;

	constructor() {
		this.checkScreenSize();
	}

	public ngOnInit(): void {
		this.panelService.registerPanel('map-drivers');
	}

	@HostListener('window:resize')
	onResize() {
		this.checkScreenSize();
	}

	private checkScreenSize() {
		this.isLargeScreen.set(window.innerWidth >= this.BREAKPOINT);
	}

	public openFullMapPage() {
		const currentParams = new URLSearchParams(window.location.search).toString();
		const base = new URL('map-popout', document.baseURI).toString();
		const url = currentParams ? `${base}?${currentParams}` : base;
		const width = 1280;
		const height = 720;
		window.open(url, '_blank', `width=${width},height=${height},resizable=yes`);
	}

	public onDriverClick(driver: any) {
		if (this.selectedDrivers().includes(driver.number)) {
			this.selectedDrivers.update((sd) => sd.filter((d) => d !== driver.number));
		} else {
			this.selectedDrivers.update((sd) => [...sd, driver.number]);
		}
	}
}
